module.exports = __webpack_public_path__ + "img/Group 10382.4ddb0121.svg";